import { useMutation, useQueryClient } from "@tanstack/react-query";
import { DocumentKeys } from "web_myplann/Api/Document/DocumentKeys";
import { invalidateDocumentListsWhenIdle } from "web_myplann/Api/Document/invalidateDocumentListsWhenIdle";
import { renameFolderInCache } from "web_myplann/Api/Document/renameFolderInCache";
import { restoreDocumentListCache } from "web_myplann/Api/Document/restoreDocumentListCache";
import {
	type DocumentTagEditRequestDTO,
	patchDocumentTagV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

type Props = {
	requestContract: DocumentTagEditRequestDTO;
};

export const useFolderEditMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationKey: DocumentKeys.mutation,
		mutationFn: processResponse(({ requestContract }: Props) =>
			patchDocumentTagV2(requestContract),
		),
		onMutate: ({ requestContract }: Props) =>
			renameFolderInCache(
				queryClient,
				requestContract.titleToEdit,
				requestContract.title,
			),
		onError: (_error, _variables, snapshot) => {
			if (snapshot) {
				restoreDocumentListCache(queryClient, snapshot);
			}
		},
		onSettled: () => invalidateDocumentListsWhenIdle(queryClient),
	});
};
